/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template "model.velocity"
 */

/**
 * THIS Template MUST remain FRAMEWORK INDEPENDENT!! It is used for Angular, Ionic, Node-Express... any JavaScript framework
 */

/* tslint:disable */


export class AdministrationFile {
    dossierCode: string; // ecf001
    name: string; // ecf001
    firstName: string; // ecf001
    dossierId: number; // ecf001
    dossierClassification: string; // ecf001
    status: string; // ecf001
    courtOfJustice: string; // ecf001
    openingDate: string; // ecf001
    lastEvolutionDate: string; // ecf001
    role: string; // ecf001


    // <editor-fold desc="From and To Json Methods" defaultstate="collapsed">
/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template &quot;model-json.velocity&quot;
 */

    /** ---- Generated part from .\ang-man\src\modules\generator\writers\common\templates\model-json.velocity */

    public static mergeJSON(instance: any, data: any): AdministrationFile {
        if (!data) { return instance; }
        if (data.dossierCode != null) {instance.dossierCode = data.dossierCode; }
        if (data.name != null) {instance.name = data.name; }
        if (data.firstName != null) {instance.firstName = data.firstName; }
        if (data.dossierId != null) {instance.dossierId = data.dossierId; }
        if (data.dossierClassification != null) {instance.dossierClassification = data.dossierClassification; }
        if (data.status != null) {instance.status = data.status; }
        if (data.courtOfJustice != null) {instance.courtOfJustice = data.courtOfJustice; }
        if (data.openingDate != null) {instance.openingDate = data.openingDate; }
        if (data.lastEvolutionDate != null) {instance.lastEvolutionDate = data.lastEvolutionDate; }
        if (data.role != null) {instance.role = data.role; }
        return instance; // ir
    }

    public fromJSON(data: any): this { // cbn001
        return AdministrationFile.mergeJSON(this, data) as any;
    }

    public static mergeJSONFromObject(target: any, object: AdministrationFile) {
        // TODO: mapping
        return object;
    }

    // toJSON ensures that only class-defined fields are exported.
    public toJSON() {
        return AdministrationFile.mergeJSONFromObject({}, this);
    }

    // Compares this AppInfo instance with another AppInfo instance, recursively.
    // Transient fields are not considered.
    public equals(other: AdministrationFile): boolean {
        return JSON.stringify(this.toJSON()) === JSON.stringify(other.toJSON());
    }

    /** ---- */


/** end of template &quot;model-json.velocity&quot; */

    // </editor-fold>

}


/** end of template "model.velocity" */
